module.exports = __webpack_public_path__ + "static/img/home7.aec521e8.png";